import { Button, Stack, TextInput } from '@mantine/core'
import { useForm } from '@mantine/form'
import { IconIdBadge2, IconPhone, IconSearch, IconShieldCheck } from '@tabler/icons-react'
import useVerificationCodeTimer from '../../hooks/useVerificationCodeTimer'
import { getComplainDetail } from '../../api/complainService'
import { IsaacComplainDetailRes } from '../../typings/complainTypes'
import { showNotification } from '../../utils/notificationUtil'
import { useState } from 'react'

interface ComplaintFormProps {
  onResult: (complaints: IsaacComplainDetailRes[]) => void
}

export default function ComplaintForm({ onResult }: ComplaintFormProps) {
  const [loading, setLoading] = useState(false)
  const { label, startTimer, isActive } = useVerificationCodeTimer()

  const form = useForm({
    initialValues: {
      phone: '',
      idCard: '',
      smsCode: '',
    },
    validate: {
      phone: (value) => (value === '' ? '请输入手机号' : !/^1[3-9]\d{9}$/.test(value) ? '请输入正确的手机号' : null),
      idCard: (value) =>
        value === ''
          ? '请输入身份证号'
          : !/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)
            ? '请输入正确的身份证号'
            : null,
      smsCode: (value) => (value === '' ? '请输入验证码' : value.length !== 6 ? '请输入6位验证码' : null),
    },
  })

  const handleSendCode = () => {
    const phoneError = form.validateField('phone')
    if (phoneError.hasError) return

    startTimer({ phone: form.values.phone, type: 15 })
  }

  const handleSubmit = async (values: typeof form.values) => {
    setLoading(true)
    try {
      const result = await getComplainDetail(values.phone, values.idCard, values.smsCode)
      onResult(result)
      if (result.length === 0) {
        showNotification.info('未查询到投诉记录')
      } else {
        showNotification.success(`查询到 ${result.length} 条投诉记录`)
      }
    } catch {
      showNotification.error('查询失败，请稍后重试')
    } finally {
      setLoading(false)
    }
  }

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Stack gap="md">
        <TextInput placeholder="请输入手机号" leftSection={<IconPhone size={16} />} {...form.getInputProps('phone')} />

        <TextInput
          placeholder="请输入身份证号"
          leftSection={<IconIdBadge2 size={16} />}
          {...form.getInputProps('idCard')}
        />

        <TextInput
          maxLength={6}
          placeholder="请输入验证码"
          leftSection={<IconShieldCheck size={16} />}
          rightSection={
            <Button size="xs" variant="subtle" onClick={handleSendCode} disabled={isActive}>
              {label}
            </Button>
          }
          rightSectionWidth={90}
          {...form.getInputProps('smsCode')}
        />

        <Button
          type="submit"
          fullWidth
          loading={loading}
          leftSection={<IconSearch size={16} />}
          style={{
            backgroundColor: '#1E40AF',
          }}
        >
          查询投诉记录
        </Button>
      </Stack>
    </form>
  )
}
